const style = {
  container: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#181a20",
    color: "#FFF",
    padding: "30px 80px",
    boxSizing: "border-box",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 99
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: '30px',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  backButton: {
    background: '#2a2f3b',
    border: '1px solid #3c4257',
    color: '#aeb9c4',
    width: '40px',
    height: '40px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  title: {
    fontSize: '28px',
    fontWeight: 600,
    margin: 0,
  },
  subtitle: {
    fontSize: '15px',
    color: '#aeb9c4',
    margin: '5px 0 0 0',
  },
  reviewButton: {
    display: 'flex',
    alignItems: 'center',
    background: '#4ecf78',
    color: '#1e212b',
    border: 'none',
    borderRadius: '10px',
    padding: '10px 20px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '40px',
    width: '100%',
  },
  formColumn: {},
  inputGroup: {
    marginBottom: '25px',
  },
  label: {
    display: "block",
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "8px",
    color: "#aeb9c4",
    display: 'flex',
    justifyContent: 'space-between',
  },
  charCount: {
    fontWeight: '400',
  },
  input: {
    width: "100%",
    height: "45px",
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    borderRadius: "12px",
    padding: "0 20px",
    boxSizing: "border-box",
    color: "#FFF",
    fontSize: "15px",
    outline: "none",
  },
  textarea: {
    height: '250px',
    paddingTop: '12px',
    resize: 'vertical',
  },
  helperText: {
    fontSize: '12px',
    color: '#aeb9c4',
    opacity: 0.7,
    marginTop: '5px',
  },
  infoBox: {
    background: 'rgba(59, 130, 246, 0.1)',
    border: '1px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '10px',
    padding: '15px',
    display: 'flex',
    alignItems: 'center',
    color: '#93c5fd',
    fontSize: '14px',
  },
};

export default style;